import React from "react";
import CDAStudyTable from "./cda.study.table";
import CDATable from "./cda.table";
import CRATable from "./cra.table";
import EPriceInfoTable from "./eprice.info.table";
import EPriceTable from "./eprice.table";
import IMVTable from "./imv.table";
import VariablesTable from "./variables.table";
import styled from "styled-components";
import { useScheduleEvents } from "../../../../app/contexts/schedule.events.context";
import { useUser } from "../../../../app/contexts/user.context";

export default function VisitSampleStrategyTables({ editOpen, setEditOpen }) {
  const {
    variablesData,
    ePrice,
    CRA,
    IMV,
    CDA,
    CDAStudy,
    ePriceInfo,
  } = useScheduleEvents();
  const { isReadOnlyUser } = useUser();

  return (
    <div>
      <VariablesTable
        editOpen={editOpen}
        setEditOpen={setEditOpen}
        data={variablesData}
        readOnly={isReadOnlyUser}
      />
      <EPriceTable data={ePrice} />
      <CRATable data={CRA} readOnly={isReadOnlyUser} />
      <IMVTable data={IMV} readOnly={isReadOnlyUser} />
      <CDATable
        data={CDA}
        setEditOpen={setEditOpen}
        readOnly={isReadOnlyUser}
      />
      <CDAStudyTable
        data={CDAStudy}
        setEditOpen={setEditOpen}
        readOnly={isReadOnlyUser}
      />
      <EPriceInfoTable data={ePriceInfo} readOnly={isReadOnlyUser} />
    </div>
  );
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  font-size: 1rem;
  border: 1px solid var(--surface-300);
  border-top: none;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;
